import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Statistic, Typography, Progress } from 'antd';
import {
  CopyrightOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';
import axios from '../../utils/request';

const { Title } = Typography;

interface Statistics {
  totalCoupons: number;
  usedCoupons: number;
}

const AdminStatistics: React.FC = () => {
  const [stats, setStats] = useState<Statistics>({
    totalCoupons: 0,
    usedCoupons: 0
  });
  const [loading, setLoading] = useState(false);

  const fetchStatistics = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/coupons/statistics');
      setStats(response.data);
    } catch (error: any) {
      console.error('获取统计数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatistics();
  }, []);

  const usageRate = stats.totalCoupons > 0 
    ? Math.round((stats.usedCoupons / stats.totalCoupons) * 100) 
    : 0;

  const remainingCoupons = stats.totalCoupons - stats.usedCoupons;

  return (
    <div style={{ padding: '24px' }}>
      <Title level={3}>核销统计</Title>
      
      <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
        <Col xs={24} sm={12} lg={6}>
          <Card loading={loading}>
            <Statistic
              title="优惠券总数"
              value={stats.totalCoupons}
              prefix={<CopyrightOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card loading={loading}>
            <Statistic
              title="已核销数量"
              value={stats.usedCoupons}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card loading={loading}>
            <Statistic
              title="剩余数量"
              value={remainingCoupons}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
        
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card title="核销率" loading={loading}>
            <div style={{ textAlign: 'center' }}>
              <Progress
                type="circle"
                percent={usageRate}
                format={percent => `${percent}%`}
                strokeColor={{
                  '0%': '#108ee9',
                  '100%': '#87d068',
                }}
                size={160}
              />
              <div style={{ marginTop: '16px', fontSize: '16px', color: '#666' }}>
                已核销 {stats.usedCoupons} / 总计 {stats.totalCoupons}
              </div>
            </div>
          </Card>
        </Col>
        
        <Col xs={24} lg={12}>
          <Card title="统计概览" loading={loading}>
            <div style={{ padding: '16px 0' }}>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    padding: '12px 0',
                    borderBottom: '1px solid #f0f0f0'
                  }}>
                    <span>核销率</span>
                    <span style={{ fontWeight: 'bold', color: '#1890ff' }}>
                      {usageRate}%
                    </span>
                  </div>
                </Col>
                
                <Col span={24}>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    padding: '12px 0'
                  }}>
                    <span>剩余优惠券</span>
                    <span style={{ fontWeight: 'bold', color: '#faad14' }}>
                      {remainingCoupons} 张
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AdminStatistics;